import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { FitnessVideos } from '../https/http';
import style from './Category.module.css'
import { FitnessCategory } from "../https/http";

const Category = () => {
     const { id } = useParams(); 
              const [videos, setVideos] = useState([]);
              const [activeVideo, setActiveVideo] = useState(null);
            
             useEffect(() => {
                   const fetchVideos = async () => {
                     try {
                       const res = await FitnessVideos(id);
               
                       const categoryBlocks = res.data?.data?.videos || [];
                       const categoryBlock = categoryBlocks.find(
                         item => Number(item.id) === Number(id)
                       );
               
                       const videoList = categoryBlock?.videos || [];
               
                       setVideos(videoList);
                       setActiveVideo(videoList[0] || null);
                     } catch (error) {
                       console.error(error);
                       setVideos([]);
                       setActiveVideo(null);
                     }
                   };
               
                   fetchVideos();
                 }, [id]);
                 const getVideoName = (url) => {
                   if (!url) return "Fitness Video";
                   return decodeURIComponent(
                     url.split("/").pop().replace(".mp4", "")
                   );
                 };
               
  return (
     <>
    <div className={style.video_layout}>
                    
                            
                            <div className={style.main_video}>
                              {activeVideo ? (
                                <>
                                  <video
                                    poster={activeVideo.video_thumbnail}
                                    src={activeVideo.video_src}
                                    controls
                                    
                                    className={style.main_player}
                                  />
                                  <h3 className={style.video_title}>
                                    {getVideoName(activeVideo.video_src)}
                                  </h3>
                                </>
                              ) : (
                                <p className={style.no_data}>No video selected</p>
                              )}
                            </div>
                    
                            {/* SIDE LIST */}
                            <div className={style.side_list}>
                              {videos.map((item) => (
                                <div
                                  key={item.id}
                                  className={`${style.side_card} ${
                                    activeVideo?.id === item.id ? style.active : ''
                                  }`}
                                  onClick={() => setActiveVideo(item)}
                                >
                                  <video
                                    src={item.video_src}
                                    muted
                                    preload="metadata"
                                    className={style.side_video}
                                  />
                                  <p className={style.side_title}>
                                    {getVideoName(item.video_src)}
                                  </p>
                                </div>
                              ))}
                            </div>
                    
                          </div>
                          </>
  )
}

export default Category